export default {
  navbar: 550,
  portfolio: 675
}



// WEBPACK FOOTER //
// ./src/styles/breakpoints.js